<template>
  <div class="head-box" data-flex="cross:center">
    <div data-flex-box="1" data-flex="cross:center" @click="fanhui">
      <img src="../../assets/images/angle-left.png" alt="">
      <p class="ml-10">返回</p>
    </div>
    <div data-flex="cross:center" class="kf" @click="toUrl(kfLink)">
      <img src="../../assets/images/fk.png" alt="">
      <p class="ml-10">在线客服</p>
    </div>
  </div>
</template>

<script>
import customEvents from '@/config/custom_events'
import bus from '@/libs/bus'
import { getRandomString } from '@/utils/string'
import { isNumber } from '@/utils/assert'
import { getWindowHeight } from '@/utils/common'
import { localStorageGet, localStorageSet, localStorageRemove } from '@/utils/storage'


export default {
  name: 'HeadKf',
  data() {
    return {
    }
  },
  methods: {
    fanhui() {
      let type = this.$route.query.type

      if (type != 1) {
        this.$router.push({ path: '/' });
        return false
      } else {
        this.$router.go(-1);
      }
    },
    toUrl(url) {
      window.location.href = url
    },
  },
  created() {
    this.kfLink = localStorageGet('kfLink') || ''
  },
  mounted() {
  }
}
</script>

<style lang="less" scoped>
.head-box {
  background: #fff;
  padding: 20px;
  box-sizing: border-box;

  div {
    img {
      width: 24px;
      height: 24px;
    }

    p {
      color: #376CFE;
      font-size: 14px;
    }
  }

  .kf {
    img {
      width: 38px;
      height: 38px;
    }
  }
}
</style>